import type { OrderPrices, OrderPricesWithUnknownDeliveryPrice } from "../OrderPrices.js";

export function hasKnownDeliveryPrice(
	price: Pick<OrderPricesWithUnknownDeliveryPrice, "deliveryPrice" | "deliveryPriceWithoutTax">,
): price is OrderPrices {
	const unvalidValues: OrderPricesWithUnknownDeliveryPrice["deliveryPrice"][] = [null, "unreachable"];
	return !unvalidValues.includes(price.deliveryPrice) && !unvalidValues.includes(price.deliveryPriceWithoutTax);
}
